import React from 'react';
import ActionButton from '@/components/buttons/ActionButton.tsx';

const TourConfigHeader = ({
  title,
  submit,
  isLoading,
  submitText = 'Dalej',
  onCancel,
  onNext,
  showSaveButton = true,
  showNextButton = false,
}: {
  title: string;
  submit: () => void;
  isLoading?: boolean;
  submitText?: string;
  onCancel?: () => void;
  onNext?: () => void;
  showSaveButton?: boolean;
  showNextButton?: boolean;
}) => {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-[32px] font-semibold tracking-tight">{title}</h1>
      <div className="flex gap-2">
        <ActionButton tone="ghost" size="sm" onClick={onCancel}>
          Anuluj
        </ActionButton>
        {showSaveButton && (
          <ActionButton
            tone="accent"
            size="sm"
            onClick={submit}
            isLoading={isLoading}
          >
            {submitText}
          </ActionButton>
        )}
        {showNextButton && onNext && (
          <ActionButton tone="accent" size="sm" onClick={onNext}>
            Dalej
          </ActionButton>
        )}
      </div>
    </div>
  );
};

export default TourConfigHeader;
